// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, reduxForm, change } from 'redux-form';
import { toggleModal } from '../../../storage/actions/modalsActions';
import Notification from '../../notification';
import defaultInitialValues from '../../../utils/reduxForm/InitialValues/companyInformationBySuperAdmin';
import ControlButtonsSection from './section/companyInformationBySuperAdmin/ControlButtonsSection';
import Fee from './section/companyInformationBySuperAdmin/Fee';

let CompanyInformationBySuperAdmin = ({
  handleSubmit,
  error,
  companyInfo,
  closeModal,
  dispatch,
}) => {
  useEffect(() => {
    if (error) Notification('error', { message: error });
  }, [error]);

  useEffect(() => {
    if (companyInfo?.value) {
      dispatch(change('companyInformationBySuperAdminReduxForm', 'companyId', companyInfo._id));
    }
  }, [companyInfo?.value, companyInfo?._id, dispatch]);

  const preventSubmitOnEnter = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      onKeyPress={preventSubmitOnEnter}
    >
      <div className="popup_body dashboard-modal-form-scroll">
        <Fee />

        <div className="field_col">
          <span className="field_name">Creator Name</span>
          <p className="dashboard-modal-static">{companyInfo?.creatorName || '—'}</p>
        </div>

        <div className="field_col">
          <span className="field_name">Creator Phone</span>
          {companyInfo?.creatorPhone ? (
            <a className="dashboard-modal-link" href={`tel:${companyInfo.creatorPhone}`}>
              {companyInfo.creatorPhone}
            </a>
          ) : (
            <p className="dashboard-modal-static">—</p>
          )}
        </div>

        <div className="field_col">
          <span className="field_name">Creator Email</span>
          {companyInfo?.creatorEmail ? (
            <a className="dashboard-modal-link" href={`mailto:${companyInfo.creatorEmail}`}>
              {companyInfo.creatorEmail}
            </a>
          ) : (
            <p className="dashboard-modal-static">—</p>
          )}
        </div>
      </div>

      <ControlButtonsSection closeModal={closeModal} />
    </Form>
  );
};

CompanyInformationBySuperAdmin = reduxForm({
  form: 'companyInformationBySuperAdminReduxForm',
})(CompanyInformationBySuperAdmin);

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = (state) => ({
  initialValues: state.modalState?.editCompanyBySuperAdmin?.type?.processingFee
    ? ({
      processingFee: state.modalState?.editCompanyBySuperAdmin?.type?.processingFee * 100,
      companyId: state.modalState?.editCompanyBySuperAdmin?.type?.value,
    })
    : defaultInitialValues,
  companyInfo: state.modalState?.editCompanyBySuperAdmin?.type,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyInformationBySuperAdmin);
